module.exports = __webpack_public_path__ + "static/app-pitch-3-17160beb0406366231f68655d2118f9b.webp";